/**
 * 費用・支払・請求（G3）共通の API フック。
 * 事業実施者は G1 の共通選択部品（features/masters/components/BusinessOperatorSelect）を使う。
 * 除外船は承認状態・期間に関係なく年度の全参加船を出すため G3 の API を使う。
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export interface VesselOption {
  id: number;
  vesselNo: number;
  displayOrder: number;
  name: string;
  nameKana: string;
  registrationNo: string;
  tonnage: number;
  businessOperatorId: number;
}

export const expenseKeys = {
  all: ['expenses'] as const,
  vessels: (year: number, operatorId: number | null) => [...expenseKeys.all, 'vessels', year, operatorId] as const,
};

/** 参加船（除外船の選択肢。GET /api/expense-statements/vessel-options） */
export function useVesselOptions(year: number, operatorId: number | null) {
  return useQuery({
    queryKey: expenseKeys.vessels(year, operatorId),
    queryFn: ({ signal }) =>
      api.get<VesselOption[]>('/expense-statements/vessel-options', { fiscalYear: year, businessOperatorId: operatorId ?? undefined }, { signal }),
    enabled: operatorId != null,
    staleTime: 60_000,
  });
}

export type BulkReportId = 'R-09' | 'R-10' | 'R-11';

/** 帳票一括作成ジョブの依頼（POST /api/report-jobs。G4） */
export function useRequestReportJob() {
  return useMutation({
    mutationFn: (input: { reportId: BulkReportId; fiscalYear: number; params: Record<string, unknown> }) =>
      api.post<{ id: number }>('/report-jobs', input),
  });
}
